import { useLocation } from 'wouter';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
const routesOrder = [
  '/',
  '/account/:accountId',
  '/upload-success',
  '/receipts',
  '/receipts/:receiptId',
  '/receipts/:receiptId/view-image',
];
const variants = {
  initial: (dir: 'forward' | 'back') => ({
    x: dir === 'forward' ? '100%' : '-100%',
    opacity: 1,
  }),
  animate: { x: 0, opacity: 1 },
};
function resolveRouteIndex(path: string) {
  for (let i = 0; i < routesOrder.length; i++) {
    const pattern = routesOrder[i].replace(/:\w+/g, '[^/]+'); // replace :params with wildcard
    const regex = new RegExp(`^${pattern}$`);
    if (regex.test(path)) return i;
  }
  return -1;
}
export default function AnimatedRoutes({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  const prevIndex = useRef<number>(resolveRouteIndex(location));
  const [direction, setDirection] = useState<'forward' | 'back'>('forward');
  useEffect(() => {
    const currentIndex = resolveRouteIndex(location);
    setDirection(currentIndex >= prevIndex.current ? 'forward' : 'back');
    prevIndex.current = currentIndex;
  }, [location]);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location}
        custom={direction}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        className="flex-grow"
        transition={{
          duration: 0.2,
          ease: [0.16, 1, 0.3, 1],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
